import withGraphqlData from 'components/hoc/withGraphqlData';

import asContentPage from 'components/hoc/asContentPage';
import GenrePage from './GenrePage';

export default asContentPage('genre', withGraphqlData(GenrePage));
